export default __webpack_public_path__ + "static/media/mercury_texture.88fde76f.jpg";